import { z } from 'zod';
// --- composable sections ---
export const OwnerIdentitySchema = z.object({
    brandName: z.string().min(1), // "EIG", "Ryze"
    brandLegalName: z.string().min(1), // "EIG Claims, Inc"
    claimsTeamSignoff: z.string().min(1), // "Your claims team at EIG"
    portalNames: z.object({
        csr: z.string().min(1),
        delegate: z.string().min(1),
        tplap: z.string().min(1),
        meet: z.string().min(1).optional(),
    }),
});
